import React, { useState, useEffect, useMemo } from "react";
import {
  Table,
  Button,
  Modal,
  Collapse,
  notification,
  Popconfirm,
  Pagination,
  List,
  Spin,
  Tooltip,
  Tabs,
  Dropdown,
  DatePicker,
  Select,
  Checkbox,
  Input,
  Switch,
} from "antd";
import { logoutUser } from "../../../../toolkit/slices/users/userSlice";
import TableComponent from "../../../components/TableComponent";
import { MdDelete, MdArchive } from "react-icons/md";
import { IoDuplicate } from "react-icons/io5";
import { FaSquareRootVariable, FaFileExcel } from "react-icons/fa6";
import { HiDocumentDuplicate } from "react-icons/hi2";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FaInbox, FaFilter } from "react-icons/fa";
import moment from "moment";
import formatIndianNumber from "../../../../../utils/formatIndianNumber";
import { useDispatch, useSelector } from "react-redux";
import {
  emptyDraft,
  setSideTab,
  saveDraft,
} from "../../../../toolkit/slices/inventories/inventorySlice";
import { PiPencilSimpleFill, PiPencilSimpleSlashFill } from "react-icons/pi";
import { MdDeleteForever } from "react-icons/md";
import dayjs from "dayjs";
import accessCheckPromise from "../../../../../utils/accessCheck";
import AuthorizationError from "../../AuthorizationError";
import ReactQuill from "react-quill";
import { IoIosMail } from "react-icons/io";
import { addProposalInventories } from "../../../../toolkit/slices/proposalInventories/proposalInventorySlice";
import isEmailAllowed from "../../../../../utils/isEmailAllowed";
import { emptyBlockInventories } from "../../../../toolkit/slices/blockInventories/blockInventorySlice";
import generateMC from "../../../../../utils/generateMC";
import generatePC from "../../../../../utils/generatePC";
const { RangePicker } = DatePicker;
let apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

const PremiumBlockList = () => {
  let userData = useSelector((state) => state.user);
  const [bookingsModalOpen, setBookingsModalOpen] = useState(false);
  const [premiumData, setPremiumData] = useState(null);
  const [subBDFData, setSubBDFData] = useState(null);
  const [fetched, setFetched] = useState(false);
  const [access, setAccess] = useState(false);
  const [draftModel, setDraftModel] = useState(false);
  const [drafts, setDrafts] = useState([]);
  const [draftDeleted, setDraftDeleted] = useState(false);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [clientOptions, setClientOptions] = useState(null);
  const [createdOptions, setCreatedOptions] = useState(null);
  const [campaignNames, setCampaignNames] = useState(null);

  const [filtersBDF, setFiltersBDF] = useState({
    client: null,
    blockedBy: null,
    dateRange: null,
  });
  const dispatch = useDispatch();
  // const location = useLocation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(searchParams.get("tab") || "1");

  useEffect(() => {
    // Synchronize the activeTab state with the URL parameter
    if (!searchParams.get("tab")) {
      setSearchParams({ tab: "1" });
    } else {
      setActiveTab(searchParams.get("tab"));
    }
  }, [searchParams, setSearchParams]);
  async function run() {
    let data = await fetchBdfData();
    if (data) {
      setPremiumData(data);
    }
  }
  useEffect(() => {
    run();
  }, [fetched, filtersBDF]);

  const fetchDrafts = async (page = 1, size = 10) => {
    setLoading(true);
    try {
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/listDrafts?page=${page}&size=${size}`,
        {
          method: "GET",
          credentials: "include",
        }
      );
      const data = await response.json();

      setDrafts(data.drafts);
      setTotal(data.draftCount); // Assuming your API returns the total count
    } catch (error) {
      console.error("Error fetching drafts:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDrafts(currentPage, pageSize);
  }, [currentPage, pageSize, draftDeleted]);

  const onPageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
    fetchDrafts(page, pageSize);
  };

  useEffect(() => {
    dispatch(setSideTab(window.location.pathname));
    fetchOptionsForFilter();
    accessCheckPromise()
      .then((res) => setAccess(res))
      .catch((error) => {
        dispatch(logoutUser());
      });
  }, []);

  async function fetchOptionsForFilter() {
    try {
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/premiumFilterData`,
        {
          method: "GET",
          credentials: "include",
        }
      );
      let responseJson = await response.json();
      setCreatedOptions(responseJson.data.createdBy);
      setClientOptions(responseJson.data.clients);
    } catch (error) {
      console.error(`Error in fetching Options for Filter: ${error.message}`);
    }
  }

  async function fetchBdfData() {
    setLoading(true);
    console.log("🎯🎯", filtersBDF);
    // return;
    try {
      let query = [];

      if (filtersBDF.client) {
        query.push(`client=${filtersBDF.client}`);
      }

      if (filtersBDF.blockedBy) {
        query.push(`blockedBy=${filtersBDF.blockedBy}`);
      }

      if (
        filtersBDF.dateRange &&
        filtersBDF.dateRange[0] &&
        filtersBDF.dateRange[1]
      ) {
        query.push(`startDate=${filtersBDF.dateRange[0]}`);
        query.push(`endDate=${filtersBDF.dateRange[1]}`);
      }

      const queryString = query.length > 0 ? `?${query.join("&")}` : "";
      let apiUrl = `${apiBaseUrl}/inventoryManagement/listPremiumBlocks${queryString}`;

      let response = await fetch(apiUrl, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });
      let responseJson = await response.json();
      let data = responseJson.data;
      if (data) {
        setLoading(false);
      }
      return data;
    } catch (err) {
      console.error(`Error: ${err.message}`);
    }
  }

  let tabs = [
    { key: "1", label: "Bookings" },
    // { key: "2", label: "On-Hold Bookings" },
  ];

  const tabChange = (key) => {
    handleClearFilters();
    setActiveTab(key);
    setSearchParams({ tab: key });
  };
  const renderTabContent = () => {
    switch (activeTab) {
      case "1":
        return <BookingsContent />;
      case "2":
        return <BookingsContent />;
      default:
        return null;
    }
  };

  const handleFiltering = (value, filterType) => {
    console.log("filterType: ", filterType, "value: ", value);
    setFiltersBDF((prevFilters) => ({
      ...prevFilters,
      [filterType]: value,
    }));
  };

  const [dates, setDates] = useState(null);
  const handleDateChange = (dates, dateStrings) => {
    setDates(dates);
    setFiltersBDF((prevFilters) => ({
      ...prevFilters,
      dateRange: dateStrings.length > 0 ? dateStrings : null,
    }));
  };
  const handleClearFilters = () => {
    setDates(null);
    setFiltersBDF({
      client: null,
      blockedBy: null,
      dateRange: null,
    });
  };

  const filters = [
    {
      key: "blockedBy",
      label: (
        <div onClick={(e) => e.stopPropagation()}>
          <h6>Created By </h6>
          <Select
            showSearch
            allowClear
            value={filtersBDF.blockedBy}
            style={{
              width: 200,
            }}
            placeholder="Client Name"
            optionFilterProp="label"
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? "")
                .toLowerCase()
                .localeCompare((optionB?.label ?? "").toLowerCase())
            }
            options={createdOptions}
            onChange={(value) => handleFiltering(value, "blockedBy")}
          />
        </div>
      ),
    },
    {
      key: "client",
      label: (
        <div onClick={(e) => e.stopPropagation()}>
          <h6>Client </h6>
          <Select
            showSearch
            allowClear
            value={filtersBDF.client}
            style={{
              width: 200,
            }}
            placeholder="Client Name  "
            optionFilterProp="label"
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? "")
                .toLowerCase()
                .localeCompare((optionB?.label ?? "").toLowerCase())
            }
            options={clientOptions}
            onChange={(value) => handleFiltering(value, "client")}
          />
        </div>
      ),
    },

    {
      key: "dateRange",
      label: (
        <div onClick={(e) => e.stopPropagation()}>
          <h6>Booking Dates </h6>
          <RangePicker onChange={handleDateChange} value={dates} />
        </div>
      ),
    },
    {
      key: "clearFilters",
      label: (
        <Button
          onClick={(e) => handleClearFilters()}
          style={{ fontSize: "12px" }}
        >
          Clear
        </Button>
      ),
    },
  ];

  const detailedBookingsColumn = [
    {
      title: "Code",
      dataIndex: "CodeNo",
      key: "CodeNo",
    },
    {
      title: "Location",
      dataIndex: "area",
      key: "area",
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
    },
  ];

  const detailedBookingsData = [
    {
      CodeNo: "HK-076",
      area: "SG Road Palladium Mall LED",
      startDate: "24 March 2024",
      endDate: "29 March 2024",
    },
    {
      CodeNo: "HK-098",
      area: "Bopal - Ghuma Road - O/S The Retail Park Bopal Bridge towards Ghuma ",
      startDate: "12 March 2024",
      endDate: "18 March 2024",
    },
    {
      CodeNo: "HK-125",
      area: "Bopal - Ghuma Road - Opp. The Retail Park Ghuma Gam towards Bopal Bridge ",
      startDate: "5 March 2024",
      endDate: "10 March 2024",
    },
    {
      CodeNo: "HK-234",
      area: "Bopal - Ghuma Road - Opp. The Retail Park Ghuma Gam towards Bopal Bridge ",
      startDate: "8 March 2024",
      endDate: "15 March 2024",
    },
  ];

  function checkIfAcceptedExist(bdfdata) {
    return bdfdata?.premiumDetails?.some((ele) => ele.accepted) || false;
  }

  const dataClients2 = useMemo(() => {
    if (!Array.isArray(premiumData)) {
      return [];
    }

    const filteredData = premiumData.filter((ele) => {
      if (
        !Array.isArray(ele?.premiumDetails) ||
        ele.premiumDetails.length === 0
      ) {
        return false;
      }

      if (activeTab === "1") {
        return ele.premiumDetails.some((detail) => detail.accepted === true);
      } else if (activeTab === "2") {
        return ele.premiumDetails.some((detail) => detail.accepted === false);
      }

      return false;
    });

    const mappedData = filteredData.map((ele, ind) => ({
      key: ind + 1,
      label: `Client: ${ele?.partyCompanyName}`,
      children: (
        <ClientInfo
          bookings={ele}
          bdfId={ele?._id}
          setFetched={setFetched}
          userId={userData?._id}
          userEmail={userData?.email}
          run={run}
          activeTab={activeTab}
        />
      ),
    }));

    return mappedData;
  }, [premiumData, activeTab, userData?._id]);

  const handleBookingClick = (key) => {
    navigate(`/clients-bdf/${key}`);
  };

  const handleViewBookings = () => {
    setBookingsModalOpen(true);
  };

  const handleItemClick = (item) => {
    dispatch(
      saveDraft({ inventories: item.inventories, bdfData: item.bdfData })
    );
    navigate(`/clients-bdf/${item._id}`);
  };
  const handleItemDelete = async (item) => {
    try {
      let requestBody = { id: item?._id };
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/deleteDraft`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );
      let responseJson = await response.json();
      if (response.ok) {
        setDraftDeleted((prev) => !prev);
        notification.success({ message: "Draft is deleted successfully!" });
      }
      if (!responseJson.success) {
        notification.error({ message: responseJson?.message });
      }
    } catch (error) {
      console.log(`Error: ${error.message}`);
    }
  };
  const BookingsContent = () => {
    return (
      <div>
        {/* <div style={{ marginBottom: "1rem", display: "flex", justifyContent: "end" }}>
      <AddNewClientComponent />
    </div> */}
        {loading ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%", // Adjust height as needed
              padding: "2rem", // Add some padding for aesthetics
            }}
          >
            <Spin size="large" />
          </div>
        ) : dataClients2 && dataClients2.length > 0 ? (
          <Collapse items={dataClients2} accordion defaultActiveKey={["1"]} />
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              justifyContent: "center",
              fontSize: "2rem",
              fontWeight: "600",
              color: "gray",
            }}
          >
            <FaInbox /> No Premium Blocked inventories yet!
          </div>
        )}

        <Modal
          title="Bookings"
          open={bookingsModalOpen}
          onCancel={() => {
            setBookingsModalOpen(false);
          }}
          centered
          className="inventory-proposal-modal"
          width={800}
        >
          <div className="bdfbased-booking-detail">
            <TableComponent
              dataSource={detailedBookingsData}
              columns={detailedBookingsColumn}
            />
          </div>
        </Modal>
      </div>
    );
  };

  if (!access) {
    return <AuthorizationError />;
  }

  return (
    <div
      className="parent-padding-container"
      style={{
        backgroundColor: "white",
        borderRadius: "12px",
        padding: "0px 20px",
      }}
    >
      <div
        style={{
          // backgroundColor: "white",
          padding: "0px 20px",
          borderRadius: "12px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "1rem",
        }}
      >
        <Tabs
          defaultActiveKey="1"
          activeKey={activeTab}
          onChange={tabChange}
          items={tabs}
        />
        <div style={{ display: "flex", gap: ".5rem" }}>
          {(activeTab == 1 || activeTab == 2 || activeTab == 3) && (
            <Dropdown
              menu={{
                items: filters,
              }}
              placement="bottomRight"
              arrow
              trigger={["click"]}
            >
              <Button>
                <FaFilter />
              </Button>
            </Dropdown>
          )}
        </div>
      </div>
      {renderTabContent()}
    </div>
  );
};

export default PremiumBlockList;

const ClientInfo = ({
  bookings,
  bdfId,
  setFetched,
  userId,
  userEmail,
  subBdfBool,
  activeTab,
  run,
}) => {
  const [inventories, setInventories] = useState(null);
  const [subBDFId, setSubBDFId] = useState(null);
  const [bookingsModalOpen, setBookingsModalOpen] = useState(false);
  const [subBDFModalOpen, setSubBDFModalOpen] = useState(false);
  const [detailedBookingsData, setDetailedBookingsData] = useState(null);
  const [detailedBookingsDataSub, setDetailedBookingsDataSub] = useState(null);
  const [packageRate, setPackageRate] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [dataBookings, setDataBookings] = useState(null);
  const [columnBookings, setColumnBookings] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [modalVisibleEmail, setModalVisibleEmail] = useState(false);
  const [bodyOfEmail, setBodyOfEmail] = useState("");
  const [downloadingPremiumBlockId, setDownloadingPremiumBlockId] = useState(null);
  const reduxInvs = useSelector((state) => state.inventoriesList.inventories);

  const downloadPremiumBlockExcel = async (record) => {
    const premiumBlockId = record?.premiumDetails?._id;
    if (!premiumBlockId) return;

    setDownloadingPremiumBlockId(premiumBlockId);
    try {
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/exportPremiumBlocksExcel?id=${premiumBlockId}`,
        { method: "GET", credentials: "include" }
      );
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error?.message || "Failed to download Excel");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      const clientName = String(
        record?.premiumDetails?.parentCompanyName || "Premium_Block"
      )
        .replace(/[<>:"/\\|?*\x00-\x1F]/g, "")
        .trim()
        .replace(/\s+/g, "_");
      link.download = `${clientName}_${record?.serial || "Report"}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      notification.error({
        message: "Excel download failed",
        description: error?.message || "Please try again.",
      });
    } finally {
      setDownloadingPremiumBlockId(null);
    }
  };

  const modules = {
    toolbar: [["bold", "italic", "underline", "link"]],
  };
  useEffect(() => {
    let data = bookings?.premiumDetails?.reduce((acc, ele, ind) => {
      let condition = activeTab == 1 ? ele.accepted : !ele.accepted;
      if (condition) {
        const { inventories, ...premiumDetails } = ele;
        console.log("🚀", ele);
        acc.push({
          serial: ele?.stamp,
          date: moment(ele?.createdAt).format("DD-MM-YYYY"),
          premiumDetails,
          blockedBy: ele?.blockedBy?.name,
          inventories,
          packageRate: ele?.packageRate,
          campaignName: ele?.campaignName,
        });
      }
      return acc;
    }, []);
    setDataBookings(data);

    let dataColumns =
      activeTab == 1
        ? [
            {
              title: "Serial No.",
              dataIndex: "serial",
              key: "serial",
            },
            {
              title: "Booked On",
              dataIndex: "date",
              key: "date",
            },
            {
              title: "Campaign Name",
              dataIndex: "campaignName",
              key: "campaignName",
            },
            {
              title: "Blocked by",
              dataIndex: "blockedBy",
              key: "blockedBy",
            },
            {
              title: "View",
              dataIndex: "view",
              key: "view",
              render: (text, record) => (
                <Button
                  onClick={() =>
                    handleViewBookings(record.inventories, record.packageRate)
                  }
                >
                  View More
                </Button>
              ),
            },
            {
              title: "Excel",
              key: "excel",
              render: (_, record) => (
                <Tooltip title="Download Excel">
                  <Button
                  type="text"
                  icon={<FaFileExcel style={{ color: "#217346", fontSize: "1.15rem" }} />}
                  loading={downloadingPremiumBlockId === record?.premiumDetails?._id}
                  onClick={() => downloadPremiumBlockExcel(record)}
                  />
                </Tooltip>
              ),
            },
            {
              title: "Edit",
              dataIndex: "Edit",
              key: "edit",
              render: (text, record) =>
                record?.premiumDetails?.blockedBy?._id === userId ? (
                  <Button
                    onClick={() =>
                      handleEditPremiumBlock(record?.premiumDetails?._id)
                    }
                    style={{ border: "none" }}
                  >
                    <PiPencilSimpleFill />
                  </Button>
                ) : (
                  <>
                    <Tooltip title="Editing not allowed">
                      <PiPencilSimpleSlashFill />
                    </Tooltip>
                  </>
                ),
            },
            {
              title: "Create BDF",
              dataIndex: "createBdf",
              key: "createBdf",
              render: (_, record) => (
                <Tooltip title="Create BDF from this Premium Block">
                  <Button
                    onClick={() => handleCreateBDFFromPremium(record)}
                    style={{ border: "none" }}
                  >
                    <HiDocumentDuplicate style={{ fontSize: "1.15rem" }} />
                  </Button>
                </Tooltip>
              ),
            },
            {
              title: "Action",
              dataIndex: "action",
              key: "action",
              render: (text, record) =>
                record?.premiumDetails?.blockedBy?._id === userId ? (
                  <Popconfirm
                    title="Archive Booking"
                    placement="topRight"
                    description="Are you sure you want to archive?"
                    onConfirm={() =>
                      handleArchivePremiumBlock(record?.premiumDetails?._id)
                    }
                    okText="Yes"
                    cancelText="No"
                  >
                    <MdArchive
                      style={{ fontSize: "1.3rem", cursor: "pointer" }}
                    />
                  </Popconfirm>
                ) : (
                  <Tooltip title="Archiving not allowed">
                    <MdDeleteForever
                      style={{ color: "gray", fontSize: "1rem" }}
                    />
                  </Tooltip>
                ),
            },
          ]
        : isEmailAllowed(userEmail)
        ? [
            {
              title: "Serial No.",
              dataIndex: "serial",
              key: "serial",
            },
            {
              title: "Booked On",
              dataIndex: "date",
              key: "date",
            },
            {
              title: "Blocked by",
              dataIndex: "blockedBy",
              key: "blockedBy",
            },
            {
              title: "View",
              dataIndex: "view",
              key: "view",
              render: (text, record) => (
                <Button
                  onClick={() =>
                    handleViewBookings(record.inventories, record.packageRate)
                  }
                >
                  View More
                </Button>
              ),
            },
            {
              title: "Excel",
              key: "excel",
              render: (_, record) => (
                <Tooltip title="Download Excel">
                  <Button
                  type="text"
                  icon={<FaFileExcel style={{ color: "#217346", fontSize: "1.15rem" }} />}
                  loading={downloadingPremiumBlockId === record?.premiumDetails?._id}
                  onClick={() => downloadPremiumBlockExcel(record)}
                  />
                </Tooltip>
              ),
            },
            {
              title: "Approve",
              dataIndex: "Approve",
              key: "approve",
              render: (text, record) => (
                <Button
                  onClick={() =>
                    handleApprovePremiumBlock(record?.premiumDetails?._id)
                  }
                >
                  Approve
                </Button>
              ),
            },
            {
              title: "Edit",
              dataIndex: "Edit",
              key: "edit",
              render: (text, record) =>
                record?.premiumDetails?.blockedBy?._id === userId ? (
                  <Button
                    onClick={() =>
                      handleEditPremiumBlock(record?.premiumDetails?._id)
                    }
                    style={{ border: "none" }}
                  >
                    <PiPencilSimpleFill />
                  </Button>
                ) : (
                  <>
                    <Tooltip title="Editing not allowed">
                      <PiPencilSimpleSlashFill />
                    </Tooltip>
                  </>
                ),
            },
            {
              title: "Action",
              dataIndex: "action",
              key: "action",
              render: (text, record) =>
                record?.bdfDetails?.createdSO ? (
                  record?.premiumDetails?.blockedBy?._id === userId ? (
                    <Popconfirm
                      title="Archive Booking"
                      placement="topRight"
                      description="Are you sure you want to archive?"
                      onConfirm={() =>
                        handleArchivePremiumBlock(record?.bdfDetails?._id)
                      }
                      okText="Yes"
                      cancelText="No"
                    >
                      <MdArchive
                        style={{ fontSize: "1.3rem", cursor: "pointer" }}
                      />
                    </Popconfirm>
                  ) : (
                    <Tooltip title="Archiving not allowed">
                      <MdDeleteForever
                        style={{ color: "gray", fontSize: "1rem" }}
                      />
                    </Tooltip>
                  )
                  ) : record?.premiumDetails?.blockedBy?._id === userId ? (
                  <Popconfirm
                    title="Delete Booking"
                    placement="topRight"
                    description="Are you sure you want to delete?"
                    onConfirm={() =>
                      handleArchivePremiumBlock(record?.premiumDetails?._id)
                    }
                    okText="Yes"
                    cancelText="No"
                  >
                    <MdDelete
                      style={{
                        color: "red",
                        fontSize: "1rem",
                        cursor: "pointer",
                      }}
                    />
                  </Popconfirm>
                ) : (
                  <Tooltip title="Deleting not allowed">
                    <MdDeleteForever
                      style={{ color: "gray", fontSize: "1rem" }}
                    />
                  </Tooltip>
                ),
            },
          ]
        : [
            {
              title: "Serial No.",
              dataIndex: "serial",
              key: "serial",
            },
            {
              title: "Booked On",
              dataIndex: "date",
              key: "date",
            },
            {
              title: "Campaign Name",
              dataIndex: "campaignName",
              key: "campaignName",
            },
            {
              title: "Blocked by",
              dataIndex: "blockedBy",
              key: "blockedBy",
            },
            {
              title: "View",
              dataIndex: "view",
              key: "view",
              render: (text, record) => (
                <Button
                  onClick={() =>
                    handleViewBookings(record.inventories, record.packageRate)
                  }
                >
                  View More
                </Button>
              ),
            },
            {
              title: "Excel",
              key: "excel",
              render: (_, record) => (
                <Tooltip title="Download Excel">
                  <Button
                  type="text"
                  icon={<FaFileExcel style={{ color: "#217346", fontSize: "1.15rem" }} />}
                  loading={downloadingPremiumBlockId === record?.premiumDetails?._id}
                  onClick={() => downloadPremiumBlockExcel(record)}
                  />
                </Tooltip>
              ),
            },
            {
              title: "Action",
              dataIndex: "action",
              key: "action",
              render: (text, record) =>
                record?.bdfDetails?.createdSO ? (
                  record?.premiumDetails?.blockedBy?._id === userId ? (
                    <Popconfirm
                      title="Archive Booking"
                      placement="topRight"
                      description="Are you sure you want to archive?"
                      onConfirm={() =>
                        handleArchivePremiumBlock(record?.bdfDetails?._id)
                      }
                      okText="Yes"
                      cancelText="No"
                    >
                      <MdArchive
                        style={{ fontSize: "1.3rem", cursor: "pointer" }}
                      />
                    </Popconfirm>
                  ) : (
                    <Tooltip title="Archiving not allowed">
                      <MdDeleteForever
                        style={{ color: "gray", fontSize: "1rem" }}
                      />
                    </Tooltip>
                  )
                  ) : record?.premiumDetails?.blockedBy?._id === userId ? (
                  <Popconfirm
                    title="Delete Booking"
                    placement="topRight"
                    description="Are you sure you want to delete?"
                    onConfirm={() => handleDeleteBDF(record?.bdfDetails?._id)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <MdDelete
                      style={{
                        color: "red",
                        fontSize: "1rem",
                        cursor: "pointer",
                      }}
                    />
                  </Popconfirm>
                ) : (
                  <Tooltip title="Deleting not allowed">
                    <MdDeleteForever
                      style={{ color: "gray", fontSize: "1rem" }}
                    />
                  </Tooltip>
                ),
            },
          ];
    setColumnBookings(dataColumns);
  }, [bookings]);

  async function handleApprovePremiumBlock(id) {
    let postData = { id };
    let response = await fetch(
      `${apiBaseUrl}/inventoryManagement/approvePremiumBlock`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(postData),
      }
    );

    let responseJson = await response.json();
    if (!response.ok) {
      notification.error({ message: responseJson.message });
    }
    if (responseJson.success) {
      notification.success({ message: responseJson.message });
      run();
    }
  }

  const handleEditPremiumBlock = (id) => {
    dispatch(emptyBlockInventories());
    // Append "?onHold" if activeTab is 2
    const queryString = activeTab === "2" ? "?onHold" : "";

    navigate(`/premiumBlock/edit/${id}${queryString}`);
  };

  const handleDeleteBDF = async (id) => {
    try {
      let requestBody = {
        bdfId: id,
      };
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/deleteCBdf`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );
      let responseJson = await response.json();
      if (!response.ok) {
        notification.error({ message: responseJson.message });
      }
      if (responseJson.success) {
        notification.success({ message: responseJson.message });
        setFetched((prev) => !prev);
      }
    } catch (err) {
      console.error("Error: ", err.message);
    }
  };

  const handleArchivePremiumBlock = async (id) => {
    try {
      let requestBody = {
        premiumId: id,
        softDelete: true,
      };
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/deletePremiumBlock`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );
      let responseJson = await response.json();
      if (!response.ok) {
        notification.error({ message: responseJson.message });
      }
      if (responseJson.success) {
        notification.success({ message: responseJson.message });
        setFetched((prev) => !prev);
      }
    } catch (err) {
      console.error("Error: ", err.message);
    }
  };

  const toEntityId = (value) => {
    if (!value) return null;
    if (typeof value === "string") return value;
    if (typeof value === "object" && value._id) return String(value._id);
    return null;
  };

  /**
   * Create BDF directly from an accepted Premium Block.
   * Prefills party + campaign + package rate + inventory dates/rates from the block,
   * then opens Direct BDF. Source premium is archived server-side after BDF create.
   */
  const handleCreateBDFFromPremium = (record) => {
    const details = record?.premiumDetails || {};
    const premiumId = toEntityId(details?._id);
    const party = details?.parentCompany || {};
    const partyId =
      toEntityId(details?.parentCompanyId) || toEntityId(party?._id);
    const partyName =
      details?.parentCompanyName || party?.name || record?.partyCompanyName;

    const inventories = (record?.inventories || []).filter(
      (item) => item?.invId?._id || item?.invId
    );

    if (!premiumId) {
      notification.error({ message: "Premium Block id missing" });
      return;
    }
    if (!inventories.length) {
      notification.error({
        message: "This Premium Block has no inventories to convert",
      });
      return;
    }

    const archivedOrMissing = inventories.filter((item) => {
      const inv = item?.invId;
      return inv?.isArchived === true;
    });
    if (archivedOrMissing.length > 0) {
      notification.warning({
        message: `${archivedOrMissing.length} inventory(ies) are archived. Remove or replace them before creating BDF.`,
      });
      return;
    }

    const missingDates = inventories.filter(
      (item) => !item?.startDate || !item?.endDate
    );
    if (missingDates.length > 0) {
      notification.error({
        message:
          "All inventories must have start and end dates before creating BDF",
      });
      return;
    }

    const info = inventories.map((item) => {
      const inv = item?.invId || {};
      const invId = inv?._id || item?.invId;
      const fromRedux = (reduxInvs || []).find(
        (r) => String(r?._id) === String(invId)
      );
      const width = inv?.width ?? fromRedux?.width;
      const height = inv?.height ?? fromRedux?.height;
      const illu = inv?.Illu ?? fromRedux?.Illu;
      const unit = inv?.unit ?? fromRedux?.unit ?? 1;
      const mediaName =
        inv?.typeOfMedia?.name ??
        fromRedux?.typeOfMedia?.name ??
        inv?.typeOfMedia ??
        fromRedux?.typeOfMedia;

      // Premium blocks usually store print/mount as 0 — use inventory defaults like normal BDF
      const printingCharge = generatePC(width, height, illu, unit, mediaName);
      const mountingCharge = generateMC(width, height, illu, unit, mediaName);

      // Keep source premium out of blocked ranges so its dates stay selectable
      const premiumBlockFiltered = (
        inv?.premiumBlock ||
        fromRedux?.premiumBlock ||
        []
      ).filter((pb) => String(pb?.premiumId) !== String(premiumId));

      return {
        _id: invId,
        codeNo: inv?.CodeNo ?? fromRedux?.CodeNo,
        location: inv?.locations?.name ?? fromRedux?.locations?.name,
        width,
        height,
        Illu: illu,
        unit,
        typeOfMedia: inv?.typeOfMedia ?? fromRedux?.typeOfMedia,
        ratePerMonth: item?.rpm ?? inv?.ratePerMonth ?? fromRedux?.ratePerMonth ?? 0,
        mountingCharge: Number(mountingCharge) || 0,
        printingCharge: Number(printingCharge) || 0,
        specialRate: Number(item?.specialRate) || 0,
        specialRatePerMonth: Number(item?.specialRatePerMonth) || 0,
        innovationRate: Number(item?.innovationRate) || 0,
        // Keep premium dates — this is a conversion, not a blank duplicate
        startDate: item?.startDate
          ? dayjs(item.startDate).isValid()
            ? dayjs(item.startDate).format("DD-MM-YYYY")
            : item.startDate
          : null,
        endDate: item?.endDate
          ? dayjs(item.endDate).isValid()
            ? dayjs(item.endDate).format("DD-MM-YYYY")
            : item.endDate
          : null,
        blockedDates: inv?.blockedDates || fromRedux?.blockedDates || [],
        Bookings: inv?.Bookings || fromRedux?.Bookings || [],
        premiumBlock: premiumBlockFiltered,
        removedOn: inv?.removedOn ?? fromRedux?.removedOn,
        isArchived: inv?.isArchived ?? fromRedux?.isArchived,
        isOverlapPossible:
          inv?.isOverlapPossible ?? fromRedux?.isOverlapPossible,
        isTrading: inv?.isTrading ?? fromRedux?.isTrading,
      };
    });

    let campaignDuration = 0;
    info.forEach((item) => {
      if (item.startDate && item.endDate) {
        const start = dayjs(item.startDate, "DD-MM-YYYY");
        const end = dayjs(item.endDate, "DD-MM-YYYY");
        if (start.isValid() && end.isValid()) {
          campaignDuration = Math.max(
            campaignDuration,
            end.diff(start, "day") + 1
          );
        }
      }
    });

    const gst = party?.gstNumber || null;
    const pan = party?.panNumber || null;

    const dt = {
      GST: gst,
      PAN: pan,
      clientName: partyName || null,
      clientId: partyId,
      campaignName: details?.campaignName
        ? String(details.campaignName).toUpperCase()
        : null,
      packageRate: details?.packageRate ?? record?.packageRate ?? null,
      approvedBy: details?.confirmedBy || null,
      billingPartyName: partyName || null,
      billingAddress: party?.address || null,
      contactPerson: party?.contactPerson || null,
      contactNumber:
        party?.contactNumber != null ? String(party.contactNumber) : null,
      emailId: party?.email || null,
      creditPeriod: 0,
      campaignDuration: campaignDuration || 0,
      // Brand is not on premium — user selects on BDF form
      brandName: null,
      brandSegment: null,
      invs: info,
      fromPremiumBlock: true,
    };

    dispatch(addProposalInventories(dt));
    navigate(`/clients-bdf/direct-bdf`, {
      state: { premiumBlockId: premiumId },
    });
  };

  const handleEdit = (value, id, field) => {
    value = value.replace(/\D/g, "");
    setInventories((prev) => {
      const index = prev.findIndex((item) => item._id === id);
      const updatedInventories = [...prev];
      updatedInventories[index] = {
        ...updatedInventories[index],
        [field]: Number(value),
      };
      return updatedInventories;
    });
  };

  // function handleViewBookings(invs, PRate) {
  //   setPackageRate(null);
  //   let data = invs?.map((ele) => {
  //     console.log("ele",ele)

  //     return {
  //       CodeNo: ele?.invId?.CodeNo,
  //       area: ele?.invId?.locations?.name,
  //       mountingCharge: ele?.mountingCharge,
  //       printingCharge: ele?.printingCharge,
  //       specialRate: ele?.specialRate,
  //       startDate: moment(ele?.startDate).format("DD-MM-YYYY"),
  //       endDate: moment(ele?.endDate).format("DD-MM-YYYY"),
  //     };
  //   });
  //   setDetailedBookingsData(data);
  //   setPackageRate(PRate);
  //   setBookingsModalOpen(true);
  // }
  function handleViewBookings(invs, PRate) {
    setPackageRate(null);
    let data = invs
      ?.filter((ele) => !ele?.suffixCode)
      .map((ele) => {
        console.log("ele", ele);

        if (ele?.invId?.isTrading === false) {
          return {
            CodeNo: <>{ele?.invId?.CodeNo}</>,
            area: ele?.invId?.locations?.name,
            // mountingCharge: ele?.mountingCharge,
            // printingCharge: ele?.printingCharge,
            specialRate: ele?.specialRate,
            startDate: moment(ele?.startDate).format("DD-MM-YYYY"),
            endDate: moment(ele?.endDate).format("DD-MM-YYYY"),
            // isTrading: ele?.invId?.isTrading,
          };
        }

        // Otherwise, include all other details
        return {
          CodeNo: ele?.invId?.CodeNo,
          area: ele?.invId?.locations?.name,
          // mountingCharge: ele?.mountingCharge,
          // printingCharge: ele?.printingCharge,
          specialRate: ele?.specialRate,
          startDate: moment(ele?.startDate).format("DD-MM-YYYY"),
          endDate: moment(ele?.endDate).format("DD-MM-YYYY"),
          // isTrading: ele?.invId?.isTrading
        };
      });
    setDetailedBookingsData(data);
    setPackageRate(PRate);
    setBookingsModalOpen(true);
  }

  // const columnBookings = [
  //   {
  //     title: "Serial No.",
  //     dataIndex: "serial",
  //     key: "serial",
  //   },
  //   {
  //     title: "Booked On",
  //     dataIndex: "date",
  //     key: "date",
  //   },
  //   {
  //     title: "Blocked by",
  //     dataIndex: "blockedBy",
  //     key: "blockedBy",
  //   },
  //   {
  //     title: "View",
  //     dataIndex: "view",
  //     key: "view",
  //     render: (text, record) => (
  //       <Button
  //         onClick={() =>
  //           handleViewBookings(record.inventories, record.packageRate)
  //         }
  //       >
  //         View More
  //       </Button>
  //     ),
  //   },
  //   {
  //     title: "Edit",
  //     dataIndex: "Edit",
  //     key: "edit",
  //     render: (text, record) =>
  //       record?.premiumDetails?.blockedBy?._id === userId ? (
  //         <Button
  //           onClick={() => handleEditPremiumBlock(record?.bdfDetails?._id)}
  //           style={{ border: "none" }}
  //         >
  //           <PiPencilSimpleFill />
  //         </Button>
  //       ) : (
  //         <>
  //           <Tooltip title="Editing not allowed">
  //             <PiPencilSimpleSlashFill />
  //           </Tooltip>
  //         </>
  //       ),
  //   },
  //   {
  //     title: "Action",
  //     dataIndex: "action",
  //     key: "action",
  //     render: (text, record) =>
  //       record?.bdfDetails?.createdSO ? (
  //         record?.premiumDetails?.blockedBy?._id === userId ? (
  //           <Popconfirm
  //             title="Archive Booking"
  //             placement="topRight"
  //             description="Are you sure you want to archive?"
  //             onConfirm={() => handleArchivePremiumBlock(record?.bdfDetails?._id)}
  //             okText="Yes"
  //             cancelText="No"
  //           >
  //             <MdArchive style={{ fontSize: "1.3rem", cursor: "pointer" }} />
  //           </Popconfirm>
  //         ) : (
  //           <Tooltip title="Archiving not allowed">
  //             <MdDeleteForever style={{ color: "gray", fontSize: "1rem" }} />
  //           </Tooltip>
  //         )
  //       ) : record?.premiumDetails?.blockedBy?._id === userId ? (
  //         <Popconfirm
  //           title="Delete Booking"
  //           placement="topRight"
  //           description="Are you sure you want to delete?"
  //           onConfirm={() => handleDeleteBDF(record?.bdfDetails?._id)}
  //           okText="Yes"
  //           cancelText="No"
  //         >
  //           <MdDelete
  //             style={{ color: "red", fontSize: "1rem", cursor: "pointer" }}
  //           />
  //         </Popconfirm>
  //       ) : (
  //         <Tooltip title="Deleting not allowed">
  //           <MdDeleteForever style={{ color: "gray", fontSize: "1rem" }} />
  //         </Tooltip>
  //       ),
  //   },
  // ];

  const columns = [
    {
      title: "Location Area",
      dataIndex: "location",
      key: "location",
    },
    // {
    //   title: "RPM",
    //   dataIndex: "ratePerMonth",
    //   key: "ratePerMonth",
    //   editable: true,
    //   render: (_, record) => (
    //     <Input
    //       value={record.ratePerMonth}
    //       disabled={true}
    //       onChange={(e) =>
    //         handleEdit(e.target.value, record._id, "ratePerMonth")
    //       }
    //     />
    //   ),
    // },
    // {
    //   title: "Special Rate Per Month",
    //   dataIndex: "specialRate",
    //   key: "specialRate",
    //   editable: false,
    //   render: (_, record) => (
    //     <Input
    //       disabled={true}
    //       value={record.specialRate}
    //       onChange={(e) =>
    //         handleEdit(e.target.value, record._id, "specialRate")
    //       }
    //     />
    //   ),
    // },
  ];

  const detailedBookingsColumn = [
    {
      title: "Code",
      dataIndex: "CodeNo",
      key: "CodeNo",
    },
    {
      title: "Location",
      dataIndex: "area",
      key: "area",
    },
    // {
    //   title: "Mounting Charge",
    //   dataIndex: "mountingCharge",
    //   key: "mountingCharge",
    // },
    // {
    //   title: "Printing Charge",
    //   dataIndex: "printingCharge",
    //   key: "printingCharge",
    // },
    // {
    //   title: "Special Rate (Duration)",
    //   dataIndex: "specialRate",
    //   key: "specialRate",
    // },
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "start Date",
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
    },
  ];

  // const dataBookings =

  const handleCheckboxChange = (record) => {
    setSelectedRows((prevSelectedRows) => {
      if (prevSelectedRows.includes(record.bdfDetails._id)) {
        return prevSelectedRows.filter((id) => id !== record.bdfDetails._id);
      } else {
        return [...prevSelectedRows, record.bdfDetails._id];
      }
    });
  };

  const handleConfirm = async () => {
    console.log("Selected Rows: ", selectedRows);

    const requestBody = {
      bdfIds: selectedRows,
      subBdfBool,
    };

    try {
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/addToSalesOrder`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );

      const responseData = await response.json();
      if (response.ok) {
        notification.success({
          message: responseData?.message,
        });
        navigate("/sales-order?tab=1");
      } else {
        notification.error({
          message: responseData?.message,
        });
      }
    } catch (error) {
      notification.error({
        message: "Error Occurred",
      });
    }
  };
  const components = {
    header: {
      cell: (props) => (
        <th
          {...props}
          style={{
            ...props.style,
            backgroundColor: "#daeffe",
          }}
        />
      ),
    },
  };

  return (
    <>
      <div>
        <h4 style={{ color: "gray" }}>Bookings Info</h4>
        <div>
          <TableComponent dataSource={dataBookings} columns={columnBookings} />
        </div>

        <Modal
          title="Bookings"
          open={bookingsModalOpen}
          onCancel={() => {
            setBookingsModalOpen(false);
          }}
          onOk={() => {
            setBookingsModalOpen(false);
          }}
          centered
          className="inventory-proposal-modal"
          width={800}
        >
          <div className="bdfbased-booking-detail">
            <TableComponent
              dataSource={detailedBookingsData}
              columns={detailedBookingsColumn}
            />
            {packageRate && (
              <div
                style={{ display: "flex", alignItems: "center", gap: ".5rem" }}
              >
                <h6 style={{ margin: "0" }}>
                  Package Rate : ₹ {formatIndianNumber(packageRate)}
                </h6>
              </div>
            )}
          </div>
        </Modal>
      </div>
    </>
  );
};
